// extracted by mini-css-extract-plugin
export default {"container":"load-more-items-module__container___MDML7","link":"load-more-items-module__link___EndEa common-module__link___Mz1h3","caret":"load-more-items-module__caret___ngBjl"};